import React, {useEffect, useState} from 'react';
import {observer} from "mobx-react-lite";
import Seo from "../components/Seo";
import Header from "../components/Header";
import {useTranslation} from "react-i18next";
import {useFetching} from "../hooks/useFetching";
import {API_CONTACTS_MAIL, API_CONTACTS} from "../utils/consts";
import ApiContactsText from "../services/Contacts/Text";
import parse from "html-react-parser";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from 'yup'
import ApiContactsMail from "../services/Contacts/Mail";
import TextareaAutosize from 'react-textarea-autosize';
import {useWebPSupportCheck} from "react-use-webp-support-check";
import cookie from "js-cookie";
import i18next from "i18next";
import Loader from "../components/Loader";
import {default_language} from "../utils/lang";

import img_telegram from '../img/telegram.png'
import bgwebp from "../img/bg.webp";
import bgpng from "../img/bg.png";


const schema = yup.object().shape({
    name: yup.string().min(3).required(),
    phone: yup.string().matches(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im).required(),
    email: yup.string().email().required(),
    question: yup.string().min(10).required(),
});

const Input = ({label, name, register, defaultValue = '', type = 'text', error, setOpacity}) => {
    return (
        <>
            <input
                id={name}
                type={type}
                className={`field ${error ? 'required' : ''}`}
                placeholder={label}
                autoComplete="off"
                onChange={e => {
                    e.target.classList.remove('required')
                }}
                defaultValue={defaultValue}
                {...register(name, {
                    onChange: () => setOpacity(false)
                })}
            />
        </>
    )
};

const ContactsPage = () => {
    const {t} = useTranslation();
    const curr_lang = i18next.language || cookie.get('i18next') || localStorage.getItem('i18nextLng') || default_language;
    const supportsWebP = useWebPSupportCheck();
    const [success, setSuccess] = useState(false);
    const [errors, setErrors] = useState([]);
    const [opacity, setOpacity] = useState(false);
    const [textAreaFocus, setTextAreaFocus] = useState(false);
    const [textAreaLength, setTextAreaLength] = useState(0);

    const [data, setData] = useState();
    // const [data, setData] = useState({name: 'Зворотний зв\'язок', description: '<p>Якщо у вас виникли запитання, не соромтесь зв’язатися з нашою командою підтримки через форму нижче:</p>', support: "<p>Зв’язатися з нашою підтримкою:</p>\n" + "\n" + "<p>welcome@champion.tm</p>"});

    const [FunctionApiContactsText] = useFetching(async () => {
        try {
            const response = await ApiContactsText.getApiContactsText(API_CONTACTS);
            setData(response.data);
        } catch {
            console.error('FunctionApiContactsText')
        }
    });

    useEffect(() => {
        FunctionApiContactsText();
    }, [curr_lang]); // eslint-disable-line react-hooks/exhaustive-deps

    const {register, handleSubmit, formState: {isValid}, reset, watch} = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    const [FunctionApiContactsMail] = useFetching(async (data) => {
        try {
            const response = await ApiContactsMail.postApiContactsMail(API_CONTACTS_MAIL, data);
            setSuccess(response.data.success);
            if (response.data.error && response.data.error.length > 0) {
                setErrors(response.data.error)
            }
            setOpacity(true);
        } catch {
            console.error('FunctionApiContactsMail')
        }
    });

    const onSubmit = (data) => {
        FunctionApiContactsMail(data);
    };

    useEffect(() => {
        if (success) {
            reset();
        }
    }, [success, reset]);

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            if (name === 'question') {
                setTextAreaLength(value.question.length)
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        console.log(errors)
        if (errors && errors.length > 0) {
            for (let i in errors) {
                document.querySelector('*[name="'+ errors[i] +'"]')?.classList.add('required');
            }
        }
    }, [errors]);

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            if (name === 'question') {
                setTextAreaLength(value.question.length)
            }
            if (errors && errors.length > 0) {
                setErrors((prevErrors) => prevErrors.filter(error => name !== error))
            }
        });
        return () => subscription.unsubscribe();
    }, [errors, watch]);

    return (
        <div className="contacts container_fluid">
            <Seo page='contacts'/>
            <div className="catalog background" style={{backgroundImage: `url(${supportsWebP ? bgwebp : bgpng})`}}>
                <Header/>
                {data ? <div className="details_content content">
                    <div className="new_games">
                        <div className="up_catalog">
                            <div className="title_block">
                                <h1>{data?.name}</h1>
                                {data?.description && parse(data.description)}
                            </div>
                        </div>
                        <div className="contacts_block">
                            <div className="contacts_forms">
                                <div className="msg" style={{opacity: opacity ? '1' : '0'}}>
                                    <p style={{color: success ? '#f1bc43' : '#c11929'}}
                                    >{success
                                        ? `${t('Дякуємо. Ми зв\'яжемося з Вами найближчим часом.')}`
                                        : `${t('Помилка. Будь ласка, виправіть введені дані.')}`}</p>
                                </div>
                                <form>
                                    <Input register={register}
                                           label={t('Ім’я')}
                                           name="name"
                                           error={errors.indexOf('name') !== -1}
                                           setOpacity={setOpacity}
                                    />
                                    <Input register={register}
                                           label={t('Номер телефону')}
                                           name="phone"
                                           error={errors.indexOf('phone') !== -1}
                                           setOpacity={setOpacity}
                                    />
                                    <Input register={register}
                                           label={t('E-mail')}
                                           name="email"
                                           error={errors.indexOf('email') !== -1}
                                           setOpacity={setOpacity}
                                    />
                                    <TextareaAutosize
                                        id='question'
                                        autoComplete="nope"
                                        className={`field ${errors.indexOf('question') !== -1 ? 'required' : ''}`}
                                        defaultValue={''}
                                        placeholder={t('Запитання')}
                                        onFocus={() => setTextAreaFocus(true)}
                                        onBlurCapture={() => setTextAreaFocus(false)}
                                        rows="1"
                                        maxLength="500"
                                        {...register('question', {
                                            onChange: () => setOpacity(false)
                                        })}
                                    />
                                    {textAreaFocus && <div className="symbol_input">{textAreaLength > 0 ? 500 - textAreaLength : t('Не менше 10-ти символів')}</div>}
                                    <button
                                        disabled={!isValid}
                                        type="button"
                                        className="validateBtn"
                                        onClick={handleSubmit(onSubmit)}
                                    >
                                        <span>{t('Відправити')}</span>
                                    </button>
                                </form>
                            </div>
                            {data.support ? <div className="location">
                                    <div className="telegram">
                                        <img src={img_telegram} alt="telegram"/>
                                        {data?.support && parse(data.support)}
                                    </div>
                                </div> : null}
                        </div>
                    </div>
                </div> : <Loader />}
            </div>
        </div>
    );
};

export default observer(ContactsPage);